import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import { webTabTitles } from "../../../data/admin";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { useEffect, useState } from "react";
import { sendData } from "../../../services/sendData";
import { emptys } from "../../../data/main";

export default function WebConnectionBox() {
  const { type, searchValues, setSearchValues, section, closeMsg } =
    useStructureContext();
  const [webTabList, setWebTabList] = useState<stdObject>({
    code: "ART",
    list: [],
  });
  const { setMsg, customUpdate, openWebInfo, logoutAction } = useMainContext();

  const callWebTabInfo = async () => {
    let code = webTabList.code;
    if (emptys.includes(searchValues[section.id]?.CODWEB?.value)) {
      const tempSearch = searchValues;
      tempSearch[section.id].CODWEB.value = code;
      setSearchValues(tempSearch);
    } else {
      code = searchValues[section.id].CODWEB.value;
    }
    setMsg("loading");
    const payloadWebTabInfo = { code };
    console.log("payloadWebTabInfo", payloadWebTabInfo);
    const responseWebTabInfo: stdObject = await sendData({
      endPoint: "callWebTab",
      payload: payloadWebTabInfo,
      logoutAction,
    });
    console.log("responseWebTabInfo", responseWebTabInfo);
    if (responseWebTabInfo.success) {
      setWebTabList({
        code,
        list: responseWebTabInfo.tabs,
      });
    }
    closeMsg();
  };

  useEffect(() => {
    callWebTabInfo();
  }, []);

  useEffect(() => {
    if (!emptys.includes(searchValues[section.id]?.CODWEB?.value)) {
      callWebTabInfo();
    }
  }, [searchValues[section.id]?.CODWEB?.value]);

  useEffect(() => {
    if (
      "webInfo" in customUpdate.current &&
      typeof customUpdate.current.webInfo === "number"
    ) {
      console.log("customUpdate.current web", customUpdate.current);
      let tempWeb = webTabList;
      tempWeb.list[customUpdate.current.webInfo] = customUpdate.current.info;
      setWebTabList({ ...tempWeb });
      customUpdate.current = {};
    }
  }, [customUpdate.current]);

  return "CODWEB" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={webTabTitles}
        data={webTabList.list}
        onDoubleClick={openWebInfo}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
